'use client'

import { useState } from 'react'
import {
  Dialog,
  DialogPanel,
  Disclosure,
  DisclosureButton,
  DisclosurePanel,
  Popover,
  PopoverButton,
  PopoverGroup,
  PopoverPanel,
} from '@headlessui/react'
import {
  GlobeAltIcon,
  Bars3Icon,
  XMarkIcon,
  HomeIcon,
  BuildingOffice2Icon,
  DocumentTextIcon
} from '@heroicons/react/24/outline'
import { ChevronDownIcon } from '@heroicons/react/20/solid'

import LogoEES from '../../uploads/Logo/EES Logo v1ees logo.svg'
import LogoSamsung from '../../uploads/Logo/samsung-logo.webp'
import { useNavigate } from 'react-router-dom'

const products_dropdown = [
  { name: 'Сите производи', description: 'Разгледај ги сите производи', href: '/производи', icon: GlobeAltIcon },
  { name: 'Резиденцијални', description: 'Разгледај ги сите резиденцијални производи', href: '/производи?filter=резиденцијални', icon: HomeIcon },
  { name: 'Комерцијални', description: 'Разгледај ги сите комерцијални производите', href: '/производи?filter=комерцијални', icon: BuildingOffice2Icon },
  { name: 'Каталози', description: 'Разгледај ги каталозите на Samsung', href: 'https://brochures.mk.samsung-climatesolutions.com/', icon: DocumentTextIcon  },
]

const contact_dropdown = [
  { name: 'Побарајте понуда', description: 'Стапете во контакт со нас.', href: '/contact', icon: DocumentTextIcon },
]
// { name: 'Кариера', description: 'Разгледај ги сите производи', href: '/кариера', icon: BriefcaseIcon },

export default function Example() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)

  return (
    <header className="bg-white h-24 sticky top-0 z-10">
      <nav aria-label="Global" className="mx-auto flex max-w-7xl items-center justify-between lg:px-4">
        <div className="flex lg:flex-1 mr-4">
          <a href="/">
            <img
              rel="preload"
              width={100}
              alt="EES"
              src={LogoEES}
              className="h-20 w-auto"
            />
          </a>
        </div>
        <div className="flex lg:hidden mr-4">
          <button
            type="button"
            onClick={() => setMobileMenuOpen(true)}
            className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-gray-700"
          >
            <span className="sr-only">Open main menu</span>
            <Bars3Icon aria-hidden="true" className="size-6" />
          </button>
        </div>
        <PopoverGroup className="hidden lg:flex lg:gap-x-12">
          <a href="/" className="text-lg font-semibold text-gray-900">
              Дома
          </a>
          {/* Listanje tipovi proizvodi vo dropdown */}
          <Popover className="relative">
            <PopoverButton className="flex items-center gap-x-1 text-lg font-semibold text-gray-900">
                Производи
              <ChevronDownIcon aria-hidden="true" className="size-5 flex-none text-gray-400" />
            </PopoverButton>
            <PopoverPanel
                transition
                className="fixed left-0 top-[90px] z-50 w-screen max-w-none overflow-hidden rounded-b-sm bg-white shadow-md transition data-[closed]:translate-y-1 data-[closed]:opacity-0 data-[enter]:duration-200 data-[leave]:duration-150 data-[enter]:ease-out data-[leave]:ease-in"
              >
                <div className="p-6 flex flex-nowrap justify-center gap-8 overflow-x-auto">
                  {products_dropdown.map((item) => (
                    <div
                      key={item.name}
                      className="group cursor-pointer relative flex flex-col flex-wrap items-center gap-y-2 rounded-lg p-6 hover:bg-gray-100 transition-all max-w-sm"
                      onClick={() => { window.location.href = item.href }}
                    >
                      <div className="flex size-14 items-center justify-center rounded-lg bg-gray-100 group-hover:bg-white">
                        <item.icon aria-hidden="true" className="size-8 text-gray-600 group-hover:text-indigo-600" />
                      </div>
                      <p className="block font-semibold text-gray-900 whitespace-wrap ">
                        {item.name}
                      </p>
                      <p className="text-center text-gray-600 whitespace-wrap">{item.description}</p>
                    </div>
                  ))}
                </div>
              </PopoverPanel>
          </Popover>
          <a href="/за-нас" className="text-lg font-semibold text-gray-900">
              За нас
          </a>
          <a href="/наши-проекти" className="text-lg font-semibold text-gray-900">
              Наши проекти
          </a>
          {/* Kontakt */}
          <Popover className="relative">
            <PopoverButton className="flex items-center gap-x-1 text-lg font-semibold text-gray-900">
              Контакт
              <ChevronDownIcon aria-hidden="true" className="size-5 flex-none text-gray-400" />
            </PopoverButton>

            <PopoverPanel
              transition
              className="fixed left-0 top-[90px] z-50 w-screen max-w-none overflow-hidden rounded-b-sm bg-white shadow-md transition data-[closed]:translate-y-1 data-[closed]:opacity-0 data-[enter]:duration-200 data-[leave]:duration-150 data-[enter]:ease-out data-[leave]:ease-in"
            >
              <div className="p-6 flex flex-nowrap justify-start gap-8 overflow-x-auto">
                
                {/* Contact Details Block */}
                <div className="group relative flex flex-col flex-nowrap items-start gap-y-2 rounded-lg p-6 bg-gray-100 hover:bg-gray-100 transition-all max-w-md">
                  <p className="block font-semibold text-gray-800 text-lg">Контакт</p>
                  <p className="text-left text-gray-600 break-words">
                    <strong>
                      ENERGY ENGINEERING SOLUTIONS DOO Skopje
                    </strong>
                    <br />
                      Ul. Filip II Makedonski br.3 DTC Soravia 10 kat
                    <br />
                    <a href="mailto:contact@ees.com.mk" className="text-indigo-600 hover:underline">
                      contact@ees.com.mk
                    </a>
                    <br />
                    <a href="tel:+38923126636" className="text-indigo-600 hover:underline">
                      +389 23126636
                    </a>
                  </p>
                </div>

                {/* Other Dropdown Items */}
                {contact_dropdown.map((item) => (
                  <div
                    key={item.name}
                    className="group relative flex flex-col flex-wrap items-center gap-y-2 rounded-lg p-6  hover:bg-gray-100 transition-all max-w-sm cursor-pointer"
                    onClick={() => { window.location.href = item.href }}
                  >
                    <div className="flex size-14 items-center justify-center rounded-lg bg-gray-100 group-hover:bg-white">
                      <item.icon aria-hidden="true" className="size-8 text-gray-600 group-hover:text-indigo-600" />
                    </div>
                    <p className="block font-semibold text-gray-900 whitespace-wrap">{item.name}</p>
                    <p className="text-center text-gray-600 whitespace-wrap">{item.description}</p>
                  </div>
                ))}
              </div>
            </PopoverPanel>
          </Popover>
          <a href="/кариера" className="text-lg font-semibold text-gray-900">
              Кариера
          </a>
        </PopoverGroup>
        <div className="hidden lg:flex lg:flex-1 lg:justify-end">
          <a href="https://samsung-climatesolutions.com/mk/b2b.html" className="">
            <img
                width={400}
                alt="EES"
                src={LogoSamsung}
                className="h-24 w-auto"
              />
          </a>
        </div>
      </nav>
      <Dialog open={mobileMenuOpen} onClose={setMobileMenuOpen} className="lg:hidden">
        <div className="fixed inset-0 z-10" />
        <DialogPanel className="fixed inset-y-0 right-0 z-10 w-full overflow-y-auto bg-white px-6 py-6 sm:max-w-sm sm:ring-1 sm:ring-gray-900/10">
          <div className="flex items-center justify-between">
            <a href="#" className="-m-1.5 p-1.5">
              <span className="sr-only">Your Company</span>
              <img
                width={100}
                alt="EES"
                src={LogoEES}
                className="h-16 w-auto"
              />
            </a>
            <button
              type="button"
              onClick={() => setMobileMenuOpen(false)}
              className="-m-2.5 rounded-md p-2.5 text-gray-700"
            >
              <span className="sr-only">Close menu</span>
              <XMarkIcon aria-hidden="true" className="size-6" />
            </button>
          </div>
          <div className="mt-6 flow-root">
            <div className="-my-6 divide-y divide-gray-500/10">
              <div className="space-y-2 py-6">
              <a
                  href="/"
                  className="-mx-3 block rounded-lg px-3 py-2 text-base/7 font-semibold text-gray-900 hover:bg-gray-50"
                >
                      Дома
                  </a>
                <Disclosure as="div" className="-mx-3">
                  <DisclosureButton className="group flex w-full items-center justify-between rounded-lg py-2 pl-3 pr-3.5 text-base/7 font-semibold text-gray-900 hover:bg-gray-50">
                      Производи
                    <ChevronDownIcon aria-hidden="true" className="size-5 flex-none group-data-[open]:rotate-180" />
                  </DisclosureButton>
                  <DisclosurePanel className="mt-2 space-y-2">
                    {[...products_dropdown].map((item) => (
                      <DisclosureButton
                        key={item.name}
                        as="a"
                        href={item.href}
                        className="block rounded-lg py-2 pl-6 pr-3 text-sm/7 font-semibold text-gray-900 hover:bg-gray-50"
                      >
                        {item.name}
                      </DisclosureButton>
                    ))}
                  </DisclosurePanel>
                </Disclosure>
                {/* <a
                  href="/контакирајте-не"
                  className="-mx-3 block rounded-lg px-3 py-2 text-base/7 font-semibold text-gray-900 hover:bg-gray-50"
                >
                  Контакирајте не
                </a> */}
                <a
                  href="/за-нас"
                  className="-mx-3 block rounded-lg px-3 py-2 text-base/7 font-semibold text-gray-900 hover:bg-gray-50"
                >
                  За нас
                </a>
                <a
                  href="/наши-проекти"
                  className="-mx-3 block rounded-lg px-3 py-2 text-base/7 font-semibold text-gray-900 hover:bg-gray-50"
                >
                  Наши проекти
                </a>
                <Disclosure as="div" className="-mx-3">
                  <DisclosureButton className="group flex w-full items-center justify-between rounded-lg py-2 pl-3 pr-3.5 text-base/7 font-semibold text-gray-900 hover:bg-gray-50">
                      Контакт
                    <ChevronDownIcon aria-hidden="true" className="size-5 flex-none group-data-[open]:rotate-180" />
                  </DisclosureButton>
                  <DisclosurePanel className="mt-2 space-y-2">
                    {[...contact_dropdown].map((item) => (
                      <DisclosureButton
                        key={item.name}
                        as="a"
                        href={item.href}
                        className="block rounded-lg py-2 pl-6 pr-3 text-sm/7 font-semibold text-gray-900 hover:bg-gray-50"
                      >
                        {item.name}
                      </DisclosureButton>
                    ))}
                  </DisclosurePanel>
                </Disclosure>
                <a
                  href="/кариера"
                  className="-mx-3 block rounded-lg px-3 py-2 text-base/7 font-semibold text-gray-900 hover:bg-gray-50"
                >
                  Кариера
                </a>
              </div>
              <div className="py-6">
                <a
                  href="https://samsung-climatesolutions.com/mk/b2b.html"
                  className="-mx-3 block rounded-lg px-3 py-2.5 text-base/7 font-semibold text-gray-900 hover:bg-gray-50"
                >
                  <img
                    width={300}
                    alt="EES"
                    src={LogoSamsung}
                    className="h-20 w-auto"
                  />
                </a>
              </div>
            </div>
          </div>

          <div className="group relative flex flex-col flex-nowrap items-start gap-y-2 rounded-lg p-6 bg-gray-100 hover:bg-gray-100 transition-all max-w-md">
            <p className="block font-semibold text-gray-800 text-lg">Контакт</p>
            <p className="text-left text-gray-600 break-words">
              <strong>
                ENERGY ENGINEERING SOLUTIONS DOO Skopje
              </strong>
              <br />
                Ul. Filip II Makedonski br.3 DTC Soravia 10 kat
              <br />
              <a href="mailto:contact@ees.com.mk" className="text-indigo-600 hover:underline">
                contact@ees.com.mk
              </a>
              <br />
              <a href="tel:+38923126636" className="text-indigo-600 hover:underline">
                +389 23126636
              </a>
            </p>
          </div>

        </DialogPanel>
      </Dialog>
    </header>
  )
}
